import React, { useRef, useState, useCallback, useEffect } from 'react';
import { number, string, node } from 'prop-types';
import cx from 'classnames';
import useStyles from 'hooks/useStyles';

import Button from 'components/Button';

import styles from './CollapseContent.scss';

function CollapseContent({ children, expandText, maxLines, className }) {
  useStyles(styles);

  const ref = useRef(null);
  const [collapsed, setCollapsed] = useState(true);

  const toggleCollapse = useCallback(() => setCollapsed(state => !state), []);

  useEffect(() => {
    const contentLineHeight = getComputedStyle(ref.current).getPropertyValue(
      'line-height',
    );
    const collapseHeight = parseFloat(contentLineHeight) * maxLines;
    if (ref.current.scrollHeight <= collapseHeight) toggleCollapse();
  }, [maxLines, toggleCollapse]);

  return (
    <div className={className}>
      <p
        ref={ref}
        style={{
          '--lineClampNumber': maxLines,
        }}
        className={cx(styles.wrapper, { [styles.expanded]: !collapsed })}
      >
        {children}
      </p>
      {collapsed && (
        <Button
          link
          ghost
          type="primary"
          onClick={toggleCollapse}
          text={expandText}
        />
      )}
    </div>
  );
}

CollapseContent.propTypes = {
  children: node.isRequired,
  expandText: string.isRequired,
  maxLines: number.isRequired,
  className: string,
};

CollapseContent.defaultProps = {
  className: '',
};
export default CollapseContent;
